<template>
  <div class="container">
    <!--每日账单-->
    <div class="daily-wrap">
      <div class="title-wrap">
        <div class="title">每日账单</div>
        <div class="download-content" @click="ExportDaily">导出数据</div>
      </div>
      <div class="header-wrap">
        <div class="date-wrap">
          <div class="desc">时间</div>
          <div class="date-selector">
            <div class="date-field" @click="changeDate(1)">
              {{ startDayDate | currenDate }}
            </div>
            <div class="range">—</div>
            <div class="date-field" @click="changeDate(2)">
              {{ endDayDate | currenDate }}
            </div>
            <div class="select-box">
              <div
                :class="[item.value === dayValue ? 'active item' : 'item']"
                v-for="(item, index) in dayNum"
                :key="index"
                @click="changeDay(item)"
              >
                {{ item.desc }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="table-wrap">
        <p-datatable
          :value="DailyData"
          showGridlines
          stripedRows
          responsiveLayout="scroll"
          :scrollable="true"
          scrollDirection="both"
          class="p-datatable-sm"
          :expandedRows.sync="expandedRows"
          @row-expand="onRowExpand"
          @row-collapse="onRowCollapse"
          expandedRowIcon="pi-chevron-up"
          collapsedRowIcon="pi-chevron-down"
        >
          <p-column
            v-for="(item, index) in dailyOption"
            :key="index"
            :field="item.prop"
            :header="item.label"
            :frozen="index === 0"
            :styles="{
              'flex-grow': '1',
              'flex-basis': index === 0 ? '100px' : '60px',
            }"
            :bodyClass="item.prop"
            :expander="item.prop === 'ad_sum' || item.prop === 'star_sum'"
          ></p-column>
          <template #expansion="slotProps">
            <div
              class="orders-subtable"
              v-if="currActivedRowIndexArr[slotProps.index] == 1"
            >
              <div class="rowDetail">
                <span>
                  <label>触发器</label>{{ slotProps.data.ad_trigger }}
                </span>
                <span>
                  <label>内购商店</label>{{ slotProps.data.ad_shop }}
                </span>
              </div>
              <div class="rowDetail">
                <span>
                  <label>通行证</label>{{ slotProps.data.ad_passcheck }}
                </span>
                <span>
                  <label>其他广告</label>{{ slotProps.data.ad_other }}
                </span>
              </div>
            </div>
            <div
              class="orders-subtable moreInfo"
              v-else-if="currActivedRowIndexArr[slotProps.index] == 2"
            >
              <div class="rowDetail">
                <span>
                  <label>星启激励A收入</label
                  >{{ slotProps.data.other_xingqi4_time }}
                </span>
                <span>
                  <label>星启激励B收入</label
                  >{{ slotProps.data.other_xingqi4_shop }}
                </span>
              </div>
              <div class="rowDetail">
                <span>
                  <label>新星计划</label>{{ slotProps.data.other_newstar }}
                </span>
                <span>
                  <label>星启计划2.0</label>
                  {{ slotProps.data.other_xingqi2 || 0 }}
                </span>
                <span>
                  <label>星启计划3.0</label>
                  {{ slotProps.data.other_xingqi3 || 0 }}
                </span>
              </div>
              <div class="rowDetail">
                <span>
                  <label>赛事奖金</label>{{ slotProps.data.other_match }}
                </span>
                <span>
                  <label>其他收入</label>{{ slotProps.data.other_dingzhi }}
                </span>
              </div>
            </div>
          </template>
          <template #empty>
            <NoData></NoData>
          </template>
        </p-datatable>
      </div>
      <div class="pagnation-wrap" v-if="DailyData.length">
        <van-pagination
          v-model="tableInfo.page"
          :total-items="tableInfo.total"
          :show-page-size="5"
          @change="changCurrentPage"
        >
          <template #prev-text>
            <van-icon name="arrow-left" />
          </template>
          <template #next-text>
            <van-icon name="arrow" />
          </template>
          <template #page="{ text }">{{ text }}</template>
        </van-pagination>
        <div class="jump-wrap">跳至</div>
        <van-dropdown-menu>
          <van-dropdown-item
            v-model="tableInfo.page"
            :options="tableOption"
            @change="changePage"
          >
          </van-dropdown-item>
        </van-dropdown-menu>
        页
      </div>
    </div>
    <!--账单详情-->
    <div class="detail-wrap">
      <div class="title-wrap">
        <div class="title">账单详情</div>
        <div class="download-content" @click="exportDetaill">导出数据</div>
      </div>
      <div class="header-wrap">
        <div class="date-wrap">
          <div class="desc">时间</div>
          <div class="date-selector">
            <div class="date-field" @click="changeDetail(1)">
              {{ startDetailDate | currenDate }}
            </div>
            <div class="range">—</div>
            <div class="date-field" @click="changeDetail(2)">
              {{ endDetailDate | currenDate }}
            </div>
            <div class="select-box">
              <div
                :class="[item.value === detailValue ? 'active item' : 'item']"
                v-for="(item, index) in detailNum"
                :key="index"
                @click="changeDetailDay(item)"
              >
                {{ item.desc }}
              </div>
            </div>
          </div>
        </div>
        <div class="type-wrap">
          <div class="money-type">
            <div class="name">货币类型</div>
            <van-dropdown-menu>
              <van-dropdown-item
                v-model="formInline.moneyType"
                :options="moneyTypeArr"
                @change="changeMoney"
              />
            </van-dropdown-menu>
          </div>
          <div class="income-type">
            <div class="name">收益来源</div>
            <van-dropdown-menu>
              <van-dropdown-item
                v-model="formInline.incomeType"
                :options="incomeTypeArr"
                @change="changeMoney"
              />
            </van-dropdown-menu>
          </div>
        </div>
      </div>
      <div class="table-wrap">
        <p-datatable
          :value="detailData"
          showGridlines
          stripedRows
          responsiveLayout="scroll"
          :scrollable="true"
          scrollDirection="both"
          class="p-datatable-sm billDetails"
        >
          <p-column
            v-for="(item, index) in detailField"
            :key="index"
            :field="item.prop"
            :header="item.label"
            :frozen="index === 0"
            :styles="{
              'flex-grow': '1',
              'flex-basis': index === 0 ? '30px' : '20px',
            }"
            :bodyClass="item.prop"
          ></p-column>
          <template #empty>
            <NoData></NoData>
          </template>
        </p-datatable>
      </div>
      <div class="pagnation-wrap" v-if="detailData.length">
        <van-pagination
          v-model="detailInfo.page"
          :total-items="detailInfo.total"
          :show-page-size="5"
          @change="changDetailPage"
        >
          <template #prev-text>
            <van-icon name="arrow-left" />
          </template>
          <template #next-text>
            <van-icon name="arrow" />
          </template>
          <template #page="{ text }">{{ text }}</template>
        </van-pagination>
        <div class="jump-wrap">跳至</div>
        <van-dropdown-menu>
          <van-dropdown-item
            v-model="detailInfo.page"
            :options="detailOption"
            @change="changeDPage"
          >
          </van-dropdown-item>
        </van-dropdown-menu>
        页
      </div>
    </div>
    <!-- 日期选择器开始时间-->
    <van-popup v-model="showStart" position="bottom">
      <van-datetime-picker
        v-model="startDayDate"
        type="date"
        :max-date="maxStartDate"
        @confirm="updateStartDate"
        @cancel="showStart = false"
      >
      </van-datetime-picker>
    </van-popup>
    <van-popup v-model="showEnd" position="bottom">
      <van-datetime-picker
        v-model="endDayDate"
        type="date"
        :max-date="maxEndDate"
        @confirm="updateEndDate"
        @cancel="showEnd = false"
      >
      </van-datetime-picker>
    </van-popup>
    <!--账单详情-->
    <van-popup v-model="showDetail" position="bottom">
      <van-datetime-picker
        v-model="startDetailDate"
        type="date"
        :max-date="maxStartDate"
        @confirm="updateStartDetail"
        @cancel="showDetail = false"
      >
      </van-datetime-picker>
    </van-popup>
    <van-popup v-model="endDetail" position="bottom">
      <van-datetime-picker
        v-model="endDetailDate"
        type="date"
        :max-date="maxEndDate"
        @confirm="updateEndDeatil"
        @cancel="endDetail = false"
      >
      </van-datetime-picker>
    </van-popup>
  </div>
</template>

<script>
const ENDTIME = new Date(new Date().toDateString()).getTime() / 1000 - 1;
console.log('ENDTIME', ENDTIME);
import {
  getIncomeDayList,
  getIncomeBillList,
  exportDayData,
  exportBillData,
} from '@/api/income';
import NoData from '@/components/NoData.vue';
import Pagination from '../pagination';
import { formatEndTime, formatStartTime } from '../../../../utils';
// import VantTable from './VantTable.vue';
const ONE_WEEK_TIME = 1000 * 60 * 60 * 24 * 7;
const ONE_DAY_TIME = 24 * 60 * 60 * 1000;
const ONE_DAY = 24 * 60 * 60 * 1000;
export default {
  name: 'indexPageTable',
  components: {
    // Table,
    // VantTable,
    // Pagination,
    'p-datatable': window.datatable,
    'p-column': window.column,
    NoData,
  },
  props: {
    closePop: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      loading: false,
      isLoading: false,
      showStart: false,
      finished: false,
      startValue: 0,
      endValue: 0,
      refreshing: false, //下拉刷新
      showEnd: false,
      showDetail: false,
      endDetail: false,
      minStartDate: '',
      minEndDate: '',
      maxEndDate: new Date(),
      maxStartDate: new Date(),
      tableInfo: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      detailInfo: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      formInline: {
        moneyType: 999,
        incomeType: 999,
      },
      detailData: [],
      startDayDate: '',
      startDetailDate: '',
      endDetailDate: '',
      endDayDate: '',
      dayValue: 7,
      detailValue: 7,
      detailOption: [
        {
          text: 1,
          value: 1,
        },
      ],
      moneyTypeArr: [
        { value: 999, text: '全部' },
        { value: 4, text: '迷你点' },
        { value: 2, text: '迷你豆' },
        { value: 3, text: '广告' },
        { value: 1, text: '贡献点' },
        { value: 5, text: '激励金' },
      ],
      incomeTypeArr: [
        { value: 999, text: '全部' },
        { value: 1, text: '地图' },
        { value: 2, text: '资源' },
        { value: 3, text: '激励金' },
      ],
      tableOption: [
        {
          text: 1,
          value: 1,
        },
      ],
      dayNum: [
        {
          desc: '7天',
          value: 7,
        },
        {
          desc: '30天',
          value: 30,
        },
        {
          desc: '90天',
          value: 90,
        },
      ],
      detailNum: [
        {
          desc: '7天',
          value: 7,
        },
        {
          desc: '30天',
          value: 30,
        },
        {
          desc: '90天',
          value: 90,
        },
      ],
      dailyOption: [
        { label: '日期', prop: 'date' },
        { label: '迷你豆', prop: 'minibean' },
        { label: '迷你点', prop: 'minipoint' },
        { label: '贡献点', prop: 'contribution' },
        { label: '广告', prop: 'ad_sum' },
        { label: '激励金', prop: 'star_sum' },
      ],
      detailField: [
        { label: '日期', prop: 'date' },
        { label: '货币类型', prop: 'money_type' },
        { label: '收益来源', prop: 'income_type' },
        { label: '数额', prop: 'num' },
      ],
      DailyData: [],
      tableData: [],
      expandedRows: [],
      showRowAdSum: false,
      showRowStarSum: false,
      currActivedRowIndexArr: [], // 每行取值 0, 不展示 1, 展示 ad_sum 2, 展示 star_sum
    };
  },
  filters: {
    currenDate(date) {
      if (typeof date == 'number') {
        date = new Date(date * 1000);
      }
      let year = date.getFullYear();
      let month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1;
      let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      return year + '-' + month + '-' + day;
    },
  },
  mounted() {
    this.fetchIncomeDayList();
    this.fetchIncomeBillList();
  },
  created() {
    //初始化时间
    const currTime = new Date(new Date(new Date()).toDateString()).getTime();
    this.startDayDate = new Date(currTime - ONE_WEEK_TIME);
    this.startDetailDate = new Date(currTime - ONE_WEEK_TIME);
    this.endDayDate = new Date(currTime - ONE_DAY_TIME);
    this.endDetailDate = new Date(currTime - ONE_DAY_TIME);
    this.minStartDate = new Date(currTime - 90 * 24 * 60 * 60 * 1000);
    this.minEndDate = new Date(currTime - 90 * 24 * 60 * 60 * 1000);
    //  this.endValue = this.currenDate(this.endDate);
  },
  methods: {
    onRowExpand(event) {
      const _className = event.className || [];
      if (_className.includes('ad_sum')) {
        this.showRowAdSum = true;
        this.showRowStarSum = false;
        this.currActivedRowIndexArr[event.rowIndex] = 1;
      } else if (_className.includes('star_sum')) {
        this.showRowAdSum = false;
        this.showRowStarSum = true;
        this.currActivedRowIndexArr[event.rowIndex] = 2;
      } else {
        this.showRowAdSum = false;
        this.showRowStarSum = false;
        this.currActivedRowIndexArr[event.rowIndex] = 0;
      }
    },
    onRowCollapse(event) {
      const _className = event.className || [];
      if (_className.includes('ad_sum')) {
        if (this.currActivedRowIndexArr[event.rowIndex] == 1) {
          this.currActivedRowIndexArr[event.rowIndex] = 0;
        } else if (this.currActivedRowIndexArr[event.rowIndex] == 2) {
          // this.currActivedRowIndexArr[event.rowIndex] = 2;
        } else {
          this.currActivedRowIndexArr[event.rowIndex] = 0;
        }
      } else if (_className.includes('star_sum')) {
        if (this.currActivedRowIndexArr[event.rowIndex] == 1) {
          // this.currActivedRowIndexArr[event.rowIndex] = 1;
        } else if (this.currActivedRowIndexArr[event.rowIndex] == 2) {
          this.currActivedRowIndexArr[event.rowIndex] = 0;
        } else {
          this.currActivedRowIndexArr[event.rowIndex] = 0;
        }
      } else {
        this.currActivedRowIndexArr[event.rowIndex] = 0;
      }
    },
    //导出每日账单
    ExportDaily() {
      this.fetchDaily();
    },
    //导出账单详情
    exportDetaill() {
      this.fetchDetail();
    },
    currenMoney(moneyType) {
      let type = '';
      switch (moneyType) {
        case 999:
          type = '全部';
          break;
        case 1:
          type = '贡献点';
          break;
        case 2:
          type = '迷你豆';
          break;
        case 3:
          type = '广告';
          break;
        case 4:
          type = '迷你点';
          break;
        case 5:
          type = '激励金';
          break;
        default:
          break;
      }
      return type;
    },
    currenIncome(incomeType) {
      let type = '';
      switch (incomeType) {
        case 999:
          type = '全部';
          break;
        case 1:
          type = '地图';
          break;
        case 2:
          type = '资源';
          break;
        case 3:
          type = '激励金';
          break;
        default:
          break;
      }
      return type;
    },
    updateStartDate() {
      console.log('updateStartDate---');
      this.tableInfo.page = 1;
      this.DailyData = []; //清空数组
      this.showStart = false;
      this.fetchIncomeDayList();
    },
    updateEndDate() {
      this.tableInfo.page = 1;
      this.DailyData = []; //清空数组
      this.showEnd = false;
      this.fetchIncomeDayList();
    },
    updateEndDeatil() {
      this.detailInfo.page = 1;
      this.detailData = []; //清空数组
      // this.fetchIncomeDayList();
      this.endDetail = false;
      this.fetchIncomeBillList();
    },
    updateStartDetail() {
      this.detailInfo.page = 1;
      this.detailData = []; //清空数组
      // this.fetchIncomeDayList();
      this.showDetail = false;
      this.fetchIncomeBillList();
    },
    changeMoney() {
      this.fetchIncomeBillList();
    },
    changeDate(index) {
      if (index === 1) {
        this.showStart = true;
      } else {
        this.showEnd = true;
      }
    },
    changeDetail(index) {
      if (index === 1) {
        this.showDetail = true;
      } else {
        this.endDetail = true;
      }
    },
    changeDay(item) {
      this.tableInfo.page = 1;
      this.DailyData = [];
      this.dayValue = item.value;
      let startTime = '';
      let endTime = '';
      const nowTime = new Date(new Date().toDateString()).getTime();
      //判断选择时间是7天/30天/90天
      endTime = nowTime - 1;
      if (this.dayValue == 7) {
        startTime = nowTime - 7 * ONE_DAY_TIME;
        this.range = 2;
      } else if (this.dayValue == 30) {
        startTime = nowTime - 30 * ONE_DAY_TIME;
        this.range = 3;
      } else {
        startTime = nowTime - 90 * ONE_DAY_TIME;
        this.range = 4;
      }
      this.startDayDate = new Date(startTime);
      this.endDayDate = new Date(endTime);
      this.fetchIncomeDayList(1);
    },
    changeDetailDay(item) {
      console.log('==================', item);
      this.detailInfo.page = 1;
      this.detailData = [];
      this.detailValue = item.value;
      let startTime = '';
      const nowTime = new Date(new Date().toDateString()).getTime();
      let end_time = parseInt(this.endDayDate.getTime() / 1000, 10);
      //判断选择时间是7天/30天/90天
      //   let endTime = nowTime - 1;
      if (this.detailValue == 7) {
        startTime = nowTime - 7 * ONE_DAY_TIME;
        this.range = 2;
      } else if (this.detailValue == 30) {
        startTime = nowTime - 30 * ONE_DAY_TIME;
        this.range = 3;
      } else {
        startTime = nowTime - 90 * ONE_DAY_TIME;
        this.range = 4;
      }
      this.startDetailDate = new Date(startTime);
      this.endDetailDate = end_time;
      this.fetchIncomeBillList();
    },
    // 查询每日列表  type:1 d代表按7/30/90天数查询
    async fetchIncomeDayList(type) {
      try {
        let start_time = formatStartTime(this.startDayDate);
        // let end_time = parseInt(this.endDayDate.getTime() / 1000, 10);
        let data = {
          start_time: start_time,
          end_time: type === 1 ? ENDTIME : formatEndTime(this.endDayDate),
          page: this.tableInfo.page,
          page_size: this.tableInfo.pageSize,
        };
        const res = await getIncomeDayList(data);
        let num = 0;
        this.tableOption = [{ text: 1, value: 1 }];
        if (res.data.list.length) {
          this.DailyData = res.data.list.map((item, index) => {
            this.currActivedRowIndexArr[index] = 0;
            //判断数据是否全部为0
            if (
              item.ad_count === 0 &&
              item.ad_other === 0 &&
              item.ad_passcheck === 0 &&
              item.ad_shop === 0 &&
              item.ad_trigger === 0 &&
              item.minibean === 0 &&
              item.minipoint === 0 &&
              item.other_xingqi2 === 0 &&
              item.other_xingqi3 === 0 &&
              item.other_xingqi4_shop === 0 &&
              item.other_xingqi4_time === 0 &&
              item.other_newstar === 0 &&
              item.other_match === 0 &&
              item.other_dingzhi === 0
            ) {
              num = num + 1;
            }
            item.ad_sum =
              (
                item.ad_passcheck +
                item.ad_trigger +
                item.ad_shop +
                item.ad_other
              ).toFixed(2) || 0;
            item.star_sum =
              (
                item.other_xingqi2 +
                item.other_xingqi3 +
                item.other_newstar +
                item.other_match +
                item.other_dingzhi +
                item.other_xingqi4_shop +
                item.other_xingqi4_time
              ).toFixed(2) || 0;
            return item;
          });
        } else this.DailyData = [];
        if (num === res.data.total_count) this.DailyData = [];
        else {
          this.tableInfo.total = res.data.total_count;
          let len = Math.ceil(this.tableInfo.total / 10);
          //设置跳至分页的取值
          if (len > 1) {
            for (let i = 1; i < len; i++) {
              this.tableOption.push({ text: i + 1, value: i + 1 });
            }
          }
        }

        // this.updateDate = res.data.update_date;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    //账单详情
    async fetchIncomeBillList() {
      let start_time = parseInt(typeof this.startDetailDate == 'number' ? this.startDetailDate : this.startDetailDate.getTime() / 1000, 10);
      let end_time = parseInt(typeof this.endDetailDate == 'number' ? this.endDetailDate : this.endDetailDate.getTime() / 1000, 10);
      try {
        this.loading = true;
        let data = {
          start_time: start_time,
          end_time: end_time,
          page: this.detailInfo.page,
          page_size: this.detailInfo.pageSize,
          money_type: this.formInline.moneyType,
          income_type: this.formInline.incomeType,
        };
        const res = await getIncomeBillList(data);
        this.detailOption = [{ text: 1, value: 1 }];
        if (res.data.list.length) {
          this.detailData = res.data.list.map(item => {
            item.money_type = this.currenMoney(item.money_type);
            item.income_type = this.currenIncome(item.income_type);
            return item;
          });
        } else this.detailData = [];
        // this.detailData = res.data.list;
        this.detailInfo.total = res.data.total_count;
        let len = Math.ceil(this.detailInfo.total / 10);
        //设置跳至分页的取值
        if (len > 1) {
          for (let i = 1; i < len; i++) {
            this.detailOption.push({ text: i + 1, value: i + 1 });
          }
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    async fetchDaily() {
      let start_time = formatStartTime(this.startDayDate);
      let end_time = formatEndTime(this.endDayDate);
      let data = {
        start_time: start_time,
        end_time: end_time,
      };
      try {
        const res = await exportDayData(data);
        this.downloadFile(res.data.url);
        this.$toast.success('每日账单下载成功');
      } catch (error) {
        console.log(error);
      }
    },
    async fetchDetail() {
      let start_time = parseInt(this.startDetailDate.getTime() / 1000, 10);
      let end_time = parseInt(this.endDetailDate.getTime() / 1000, 10);
      let data = {
        start_time: start_time,
        end_time: end_time,
      };
      try {
        const res = await exportBillData(data);
        this.downloadFile(res.data.url);
        this.$toast.success('账单详情下载成功');
      } catch (error) {
        console.log(error);
      }
    },
    //浏览器下载函数
    downloadFile(url) {
      let a = document.createElement('a');
      a.href = url;
      a.download = url.split('/').pop();
      a.click();
    },
    currenDate(date) {
      if (typeof date == 'number') {
        date = new Date(date * 1000);
      }
      console.log('date', date.getFullYear());
      let year = date.getFullYear();
      let month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1;
      let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      return year + '' + month + '' + day;
    },
    changePage() {
      this.fetchIncomeDayList();
    },
    changeDPage() {
      this.fetchIncomeBillList();
    },
    changCurrentPage(page) {
      this.tableInfo.page = page;
      this.fetchIncomeDayList();
    },
    changDetailPage(page) {
      this.detailInfo.page = page;
      this.fetchIncomeBillList();
    },
  },
};
</script>

<style lang="less" scoped>
.daily-wrap {
  .title-wrap {
    display: flex;
    justify-content: space-between;
    margin-bottom: 24px;
    .title {
      color: #000000;
      font-size: 34px;
      font-weight: 500;
    }
    .download-content {
      color: #2b6ddf;
      font-size: 28px;
    }
  }
  .pagnation-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 43px;
    .van-pagination {
      margin-right: 30px;
    }
    /deep/.van-pagination__item {
      border: 1px solid #fd9b21;
    }
    .jump-wrap {
      color: #8c8c8c;
      font-size: 28px;
    }
    .van-dropdown-menu {
      margin: 0 10px;
    }
  }
}
.detail-wrap {
  margin-top: 59px;
  .title-wrap {
    display: flex;
    justify-content: space-between;
    margin-bottom: 24px;
    .title {
      color: #000000;
      font-size: 34px;
      font-weight: 500;
    }
    .download-content {
      color: #2b6ddf;
      font-size: 28px;
    }
  }
  .type-wrap {
    display: flex;
    margin-top: 38px;
    justify-content: space-between;
    .money-type {
      display: flex;
      align-items: center;
      margin-top: 0;
      .name {
        font-size: 26px;
        color: #000000;
        margin-right: 12px;
      }
      /deep/.van-dropdown-menu {
        width: 185px;
        height: 60px;
        border-radius: 8px;
        background: #ffffff;
        border: none;
        //  border: 1px solid #d9d9d9;
        /deep/.van-dropdown-menu__bar {
          border: none;
        }
      }
      /deep/.van-dropdown-menu__title--active {
        color: #fd9b21;
      }
      /deep/.van-dropdown-item__option--active {
        color: #fd9b21;
      }
      /deep/.van-dropdown-item__option--active .van-dropdown-item__icon {
        color: #fd9b21;
      }
    }
    .income-type {
      display: flex;
      align-items: center;
      .name {
        font-size: 26px;
        color: #000000;
        margin-right: 12px;
      }
      /deep/.van-dropdown-menu {
        width: 185px;
        height: 60px;
        border-radius: 4px;
        background: #ffffff;
        border: none;
        //  border: 1px solid #d9d9d9;
        /deep/.van-dropdown-menu__bar {
          border: none;
        }
      }
      /deep/.van-dropdown-menu__title--active {
        color: #fd9b21;
      }
      /deep/.van-dropdown-item__option--active {
        color: #fd9b21;
      }
      /deep/.van-dropdown-item__option--active .van-dropdown-item__icon {
        color: #fd9b21;
      }
    }
  }
  .pagnation-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 43px;
    .van-pagination {
      margin-right: 30px;
    }
    /deep/.van-pagination__item {
      // border: 1px solid #fd9b21;
      border: none;
      background: none;
      font-size: 32px;
      color: #8c8c8c;
    }
    /deep/.van-pagination__item--active {
      color: #fd9b21;
      font-size: 32px;
    }
    /deep/.van-dropdown-menu__title::after {
      display: none;
    }
    .jump-wrap {
      color: #8c8c8c;
      font-size: 28px;
    }
    .van-dropdown-menu {
      margin: 0 10px;
    }
  }
}
</style>
<style lang="less">
.orders-subtable {
  display: block;
  width: 100%;
  .rowDetail {
    width: 60%;
    margin: auto;
    display: flex;
    justify-content: flex-start;
    span {
      margin: 4px 59px 4px 0;
      font-size: 24px;
      color: #000;
      label {
        color: #595959;
        padding-right: 16px;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
  &.moreInfo .rowDetail {
    width: 60%;
  }
}
// .p-frozen-column {
//   flex-grow: 1 !important;
//   flex-basis: 164px !important;
//   width: 260px;
// }
</style>
<style
  src="../../../../assets/styles/filterPanel.less"
  lang="less"
  scoped
></style>
